"use client";

import { useContext, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import ResponsiveMenu from "./ResponsiveMenu";
import ResponsiveMenuContext from "@/contexts/responsiveMenu.context";
import style from "./ResponsiveMenuContainer.module.scss";

const ResponsiveMenuContainer = () => {
  const nodeRef = useRef<HTMLDivElement>(null);
  const { isResponsiveMenuDisplayed, setIsResponsiveMenuDisplayed } =
    useContext(ResponsiveMenuContext);

  return (
    <div className={style.container}>
      <CSSTransition
        nodeRef={nodeRef}
        in={isResponsiveMenuDisplayed}
        timeout={200}
        classNames="responsiveMenuTransition"
        unmountOnExit
      >
        <ResponsiveMenu ref={nodeRef} props={{}} />
      </CSSTransition>
    </div>
  );
};

export default ResponsiveMenuContainer;
